import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React, { useEffect, useState } from 'react';
import { siteUrl } from "../../../utils/siteUrl";
import './article-autopauta.scss';

const ArticleAutopauta = props => {
    const { infoAutopauta, slugPrefix } = props;

    const isExternal = infoAutopauta.botonRedireccion && infoAutopauta.botonRedireccion.includes("http") 

    var homeLink = siteUrl + '/'

    const [pageLoad, setPageLoad] = useState(false);

    
    useEffect(() => {
        setPageLoad(true);
    }, [])

    if (infoAutopauta.tipoDeAutopauta === 'Imagen-Descripción') {
        return (
            <a href={infoAutopauta.botonRedireccion === null ? '#' : isExternal ? infoAutopauta.botonRedireccion : homeLink + infoAutopauta.botonRedireccion} className="f-top-redirect-autopauta" target={isExternal ? '_blank' : ''} rel={isExternal ? "noopener noreferrer" : ""}>
                <label className="f-product-title">
                    {documentToReactComponents(infoAutopauta.tituloProductoDestacado1.json)}
                </label>
                <img
                    className="f-img-product"
                    src={pageLoad ? props.infoAutopauta.imagenDestacada.file.url : props.infoAutopauta.imagenDestacada.fixed.base64}
                    alt={props.infoAutopauta.imagenDestacada.description}
                />
                <span className="f-product-subtitle">
                    {props.infoAutopauta.subtituloProductoDestacado}
                </span>
                <label className="f-product-description">
                    {infoAutopauta.descripcion1 !== null ? documentToReactComponents(infoAutopauta.descripcion1.json) : ''}
                </label>
            </a>
        )
    } else if (infoAutopauta.tipoDeAutopauta === 'Imagen Sola') {
        return (
            <>
                <a href={infoAutopauta.botonRedireccion === null ? '#' : isExternal ? infoAutopauta.botonRedireccion : homeLink + infoAutopauta.botonRedireccion} className="f-link-autopauta" target={isExternal ? '_blank' : ''} rel={isExternal ? "noopener noreferrer" : ""}>
                    <img
                        className="f-img-autopauta"
                        src={pageLoad ? props.infoAutopauta.imagenDestacada.file.url : props.infoAutopauta.imagenDestacada.fixed.base64}
                        alt={props.infoAutopauta.imagenDestacada.description}
                    // height={props.infoAutopauta.imagenDestacada.file.details.image.height}
                    />
                </a>
            </>
        )
    } else {
        return (
            <>
                <h2 className="f-title-section-recommended-articles">
                    {infoAutopauta.tituloArticulosRelacionados}
                </h2>
                {infoAutopauta.articulosRelacionados !== null && infoAutopauta.articulosRelacionados.map((article, index) => {

                    return (
                        <div className="f-recommended-article" key={index}>
                            <a href={slugPrefix + article.slug}>
                                <img
                                    className="f-autopauta-article-img"
                                    src={pageLoad ? article.imagenArticuloAutopauta.file.url : article.imagenArticuloAutopauta.fixed.base64}
                                    alt={article.imagenArticuloAutopauta.description}
                                />
                            </a>
                            <a href={slugPrefix + article.slug}>
                                <h3 className="f-autopauta-article-title">{article.tituloArticulo}</h3>
                            </a>
                        </div>
                    )

                })}
            </>
        )
    }
}

export default ArticleAutopauta
